import Menu from './Compartido/Menu.jsx';
import TextosGraciasPeticion from './GraciasPeticion/TextosGraciasPeticion.jsx';
import Footer from './Compartido/Footer.jsx';

const GraciasPeticion = (props) => {
    return (
        <main>
            <Menu
                idiomas={props.idiomas}
                lang={props.lang}
                config={props.config}
                ruta={props.ruta}
            />
            <TextosGraciasPeticion />
            <Footer
                datos={props.websgrupo}
                config={props.config}
                lang={props.lang}
                ruta={props.ruta}
            />
        </main>
    )
}

export default GraciasPeticion;
